export const FIRST_AXES_VIEW = 'first-axes-view';
export const SECOND_AXES_VIEW = 'second-axes-view';
/** å¯¹ç§°æ¡å½¢å¾çåç» key å¼ */
export const SERIES_FIELD_KEY = 'series-field-key';
